// Generated by purs version 0.15.15
import * as Ouroboros_Models_Ui_FeedbackSuccessModalPhase from "../Ouroboros.Models.Ui.FeedbackSuccessModalPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_FeedbackSubmission from "../Ouroboros.Programs.Controllers.FeedbackSubmission/index.js";
var successPhaseFromBoolean = function (value) {
    if (value) {
        return Ouroboros_Models_Ui_FeedbackSuccessModalPhase.feedbackSuccessModalPhaseNamespace.visible;
    };
    return Ouroboros_Models_Ui_FeedbackSuccessModalPhase.feedbackSuccessModalPhaseNamespace.hidden;
};
var readState = function (v) {
    return v;
};
var buildFeedbackSubmissionViewProps = function (input) {
    return {
        feedbackContentsValue: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.feedbackContents)),
        successPhase: successPhaseFromBoolean(readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.showSuccess))),
        onFeedbackContentsChange: function (value) {
            return Ouroboros_Programs_Controllers_FeedbackSubmission.runFeedbackSubmissionAction(input.kernel.controller.updateFeedbackContents(value));
        },
        onSubmit: function (request) {
            return Ouroboros_Programs_Controllers_FeedbackSubmission.runFeedbackSubmissionAction(input.kernel.controller.submit(request));
        },
        onCloseSuccessModal: function (v) {
            return Ouroboros_Programs_Controllers_FeedbackSubmission.runFeedbackSubmissionAction(input.kernel.controller.closeSuccessModal);
        },
        onBackToHome: function (v) {
            return Ouroboros_Programs_Controllers_FeedbackSubmission.runFeedbackSubmissionAction(input.kernel.controller.backToHome(input.documentSelectionRoute));
        }
    };
};
export {
    buildFeedbackSubmissionViewProps
};
//# sourceMappingURL=index.js.map
